document.addEventListener("DOMContentLoaded", function () {
  jQuery(function ($) {
    if ($("body").hasClass("single-post-podcast")) {
      let $links = $(".post-content a");

      $.each($links, function (k, obj) {
        let $obj = $(obj);
        let href = $obj.attr("href");

        let pattern = new RegExp(
          /(https:\/\/traffic.libsyn.com\/secure\/boxoffice(.*))|(http:\/\/traffic.libsyn.com\/boxoffice(.*))/g
        );

        if (pattern.test(href)) {
          $obj.addClass("c-button").addClass("b-podcast-download");
        }
      });
    }
  });
});
